/**
 * Constants for the join funnel (3-step pre-payment capture).
 */

import { POSITIONING_VARIANTS, POSITIONING_VARIANT_STORAGE_KEY, type PositioningVariant } from './payment';

export { POSITIONING_VARIANTS, POSITIONING_VARIANT_STORAGE_KEY };
export type { PositioningVariant };

/**
 * US states that don't have lab partners yet. Showing a soft warning when one
 * of these is selected on Step 3 — user can still join and upload their own
 * bloodwork.
 */
export const LAB_UNAVAILABLE_STATES = ['HI', 'RI'] as const;

/**
 * Hard floor: under-18 cannot proceed past Step 2 (Continue button disabled).
 */
export const MIN_AGE = 18;

/**
 * Soft warning threshold: Catch's risk models are tuned for adults under 85.
 * Continue is still allowed; just shows an inline notice.
 */
export const SOFT_AGE_WARNING_THRESHOLD = 85;

/**
 * Maximum age for which the funnel still treats DOB as plausible. Beyond this
 * we treat the input as a typo and show the same soft warning copy as ≥85.
 */
export const MAX_PLAUSIBLE_AGE = 120;

/**
 * localStorage key for the funnel session token (X-Funnel-Session header
 * value). Distinct from the legacy visitor-token used by member-backend.
 */
export const FUNNEL_SESSION_TOKEN_KEY = 'funnel-session-token';

/**
 * localStorage key for the funnel session UUID. Stamped onto Stripe
 * subscription metadata so catch-backend's webhook can link the funnel
 * session to the new member at `customer.subscription.created`. Opaque,
 * non-authenticating — the token (above) is what authorizes lead reads.
 */
export const FUNNEL_SESSION_ID_KEY = 'funnel-session-id';
